<template>
    <div class="wrapper">
      <div v-if="!isGenerateLead && isPermissionImportCSV" class="text-end">
        <sc-button variant="secondary" @click="handleClickOpenLead"
          >เพิ่ม lead</sc-button
        >
      </div>
      <div v-if="isGenerateLead">
        <div class="text-end">
          <sc-button variant="danger" @click="clearGenerateLead"
            >ปิดเพิ่ม lead</sc-button
          >
        </div>
        <div class="lead-generate">
          <div class="row mb-3">
            <div class="col-8">
              <div class="label">ชื่อ Lead</div>
              <el-input v-model="leadName" placeholder="เพิ่มชื่อ Lead" />
            </div>
            <div class="col-4">
              <div class="label">เลือกวัน / เวลา เริ่มต้น - สิ้นสุด</div>
              <date-picker
                v-model="daterange"
                type="daterange"
                style="width: 100%"
              ></date-picker>
            </div>
          </div>
          <div class="row mb-3">
            <label class="select-input ms-3">
              <span>เลือกทุกโครงการ</span>
              <input
                v-model="isAllProject"
                :value="true"
                type="radio"
                name="type"
              />
              <span class="checkmark radio"></span>
            </label>
            <label class="select-input">
              <span>เลือกบางโครงการ</span>
              <input
                v-model="isAllProject"
                :value="false"
                type="radio"
                name="type"
              />
              <span class="checkmark radio"></span>
            </label>
          </div>
          <div class="row mb-3">
            <div class="col-4">
              <div class="label">type ของโครงการ</div>
              <el-select
                v-model="projectType"
                :disabled="isAllProject"
                style="width: 100%"
                placeholder="เลือกทั้งหมด"
                clearable
              >
                <el-option
                  v-for="t in projectTypesDropdown"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-4">
              <div class="label">Segment โครงการ</div>
              <el-select
                :value="segmentType"
                :disabled="
                  isAllProject || !!areaTypeStart || !!areaTypeEnd
                "
                multiple
                style="width: 100%"
                placeholder="เลือกทั้งหมด"
                clearable
                @input="handleChangeValue('segment', $event)"
              >
                <el-option
                  v-for="t in segmentChanging"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-4">
              <div class="label">Project Group</div>
              <el-select
                :value="groupType"
                :disabled="isAllProject"
                multiple
                style="width: 100%"
                placeholder="เลือกทั้งหมด"
                clearable
                @input="handleChangeValue('group', $event)"
              >
                <el-option
                  v-for="t in groupChanging"
                  :key="t.project_group"
                  :label="t.project_group"
                  :value="t.project_group"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2">
              <div class="label">อายุบ้านเริ่มต้น (ค.ศ.)</div>
              <el-input
                v-model="houseAgeStart"
                type="number"
                class="length-home"
                placeholder="XXXX"
              />
            </div>
            <div class="mt-4">-</div>
            <div class="col-2">
              <div class="label">อายุบ้านสิ้นสุด (ค.ศ.)</div>
              <el-input
                v-model="houseAgeEnd"
                type="number"
                class="length-home"
                placeholder="XXXX"
              />
            </div>
            <div class="col-2">
              <div class="label">เดือนที่หมดอายุ</div>
              <el-select
                v-model="expiredMonth"
                style="width: 100%"
                placeholder="เลือกทั้งหมด"
                clearable
              >
                <el-option
                  v-for="t in monthDropdown"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-4">
              <div class="label">พื้นที่ใช้สอย (ตรม.)</div>
              <div class="row">
                <div class="col-5">
                  <el-input
                    v-model="areaTypeStart"
                    :disabled="segmentType && segmentType.length > 0"
                    type="number"
                    placeholder="ช่วงเริ่มต้น"
                  />
                </div>
                -
                <div class="col-5">
                  <el-input
                    v-model="areaTypeEnd"
                    :disabled="segmentType && segmentType.length > 0"
                    type="number"
                    placeholder="ช่วงสิ้นสุด"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-6">
              <div class="label">หมวดหมู่บริการ</div>
              <service-group-selector
                v-model="serviceGroupType"
                :disabled="!!serviceIds && serviceIds !== ''"
              ></service-group-selector>
              <div class="row mt-3 mb-2 align-items-center">
                <label class="select-input ms-3">
                  <span>เคยซื้อแพ็กเกจนี้</span>
                  <input
                    v-model="isNeverBuyPackage"
                    :value="false"
                    type="radio"
                    name="packagePurchase"
                  />
                  <span class="checkmark radio"></span>
                </label>
                <label class="select-input">
                  <span>ไม่เคยซื้อแพ็กเกจนี้</span>
                  <input
                    v-model="isNeverBuyPackage"
                    :value="true"
                    type="radio"
                    name="packagePurchase"
                  />
                  <span class="checkmark radio"></span>
                </label>
              </div>
              <div class="label">Package ID</div>
              <el-input
                v-model="packageIds"
                class="w-100 input"
                placeholder="เช่น 123,124,125"
                @input="replaceNonNumericToPackageIds"
              />
            </div>
            <div class="col-6">
              <div class="label">หมายเลขบริการ (service id)</div>
              <el-input
                v-model="serviceIds"
                :disabled="!!serviceGroupType"
                class="w-100 input"
                type="textarea"
                rows="5"
                placeholder="Ex: 234,345,670"
                @input="replaceNonNumericToServiceIds"
              ></el-input>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-4 mb-3">
              <div class="label">เลือกช่วงเวลา</div>
              <date-picker
                v-model="packageExpire"
                type="daterange"
                style="width: 100%"
              ></date-picker>
            </div>
            <div class="col-3 mb-3">
              <div class="label">เลือกประเภทช่วงเวลา</div>
              <el-select
                v-model="packagePeriodType"
                :disabled="!packageExpire"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="t in packagePeriodTypeMapping"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-4 mb-4">
              <div class="label">Agent</div>
              <el-select
                v-model="agentId"
                style="width: 100%"
                placeholder="เลือกทั้งหมด"
                clearable
              >
                <el-option
                  v-for="t in agentDropdown"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </div>
            <div class="col-4 mb-3">
              <div class="label">สถานะการขาย</div>
              <el-select
                :value="saleStatus"
                :disabled="!agentId"
                multiple
                style="width: 100%"
                placeholder="เลือกทั้งหมด"
                clearable
                @input="handleChangeValue('status', $event)"
              >
                <el-option
                  v-for="t in statusLeadContract"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
              <div class="status-detail">
                ดึงสถานะย้อนหลัง 40วัน จากการเพิ่ม
              </div>
            </div>
            <div class="col-2 mb-3">
              <div class="label">คะแนน (Rating)</div>
              <el-select
                v-model="rating"
                style="width: 100%"
                placeholder="เลือกทั้งหมด"
                clearable
              >
                <el-option
                  v-for="t in ratingDropdown"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2 mt-4 mb-3">
              <label class="select-input"
                >ไม่เคยโทร
                <input v-model="isNeverCall" type="checkbox" />
                <span class="checkmark checkbox"></span>
              </label>
            </div>
          </div>
          <div v-if="!isAllProject">
            <label class="label">โครงการที่รองรับ</label>
            <lead-project-selector
              v-model="projectSelect"
              :project-ids-by-filter="projectIdsByFilter"
              :project-type="projectType"
              @projectIdsByType="handleProjectIdsByType"
            ></lead-project-selector>
          </div>
          <div class="text-end mb-5">
            <sc-button variant="primary" @click="handleClickCreate"
              >เพิ่ม lead</sc-button
            >
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row mb-4">
          <div class="col-4">
            <div class="label">ชื่อ Lead</div>
            <el-input v-model="query.leadName" placeholder="ค้นหา" />
          </div>
          <div class="col-4">
            <div class="label">สถานะ</div>
            <el-select
              v-model="query.leadStatus"
              style="width: 100%"
              placeholder="เลือกทั้งหมด"
              clearable
            >
              <el-option
                v-for="t in statusLead"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </div>
          <div class="col-2 text-end mt-4">
            <sc-button variant="primary" @click="handleClickSearch"
              >ค้นหา</sc-button
            >
          </div>
        </div>
      </div>
      <div>
        <p v-if="total" class="mt-2">{{ totalCount }}</p>
        <div class="lead-manage-row header">
          <div class="cell">เลขที่</div>
          <div class="cell">ชื่อ Lead</div>
          <div class="cell">วัน / เวลา เริ่มต้น - สิ้นสุด</div>
          <div class="cell">สถานะ Lead</div>
          <div class="cell">ผู้นำเข้า Lead</div>
          <div class="cell action">Action</div>
        </div>
        <div class="mb-4">
          <div
            v-for="lead in leadList"
            :key="lead.id"
            :class="lead.isDisable ? 'lead-disabled' : ''"
            class="lead-manage-row"
          >
            <div class="cell">{{ lead.id }}</div>
            <router-link :to="lead.route" class="cell">
              {{ lead.name }}
            </router-link>
            <div class="cell">{{ lead.durationDate }}</div>
            <div
              :class="lead.leadStatusClassList"
              class="lead-text-status-badge list"
            >
              {{ lead.leadStatusTH }}
            </div>
            <div class="cell">{{ lead.admin }}</div>
            <div class="action">
              <div>
                <span
                  class="voucher-remove-button"
                  @click="handleClickRemove(lead.id)"
                >
                  <img src="/static/icons/trash.svg" alt="ลบ" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end">
        <el-pagination
          :total="total"
          :page-size="10"
          :current-page="query.page"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import DatePicker from "@/lib/components/DatePicker";
import ScButton from "@/lib/components/ScButton";
import ServiceGroupSelector from "@/lib/components/ServiceGroupSelector";
import {
  leadHomeManagementStatusENG,
  leadStatus,
  packagePeriodTypeMapping,
  permissionRole
} from "@/lib/mapper";
import { Input, Option, Pagination, Select } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import LeadProjectSelector from "../component/LeadProjectSelector";

export default {
  components: {
    "el-input": Input,
    "date-picker": DatePicker,
    "sc-button": ScButton,
    "lead-project-selector": LeadProjectSelector,
    "el-select": Select,
    "el-option": Option,
    "service-group-selector": ServiceGroupSelector,
    "el-pagination": Pagination,
  },
  data() {
    const pageWrapper = {
      title: "ข้อมูล Lead",
      hasPad: true,
    };

    const projectTypesDropdown = [
      { value: "H", label: "แนวสูง" },
      { value: "L", label: "แนวราบ" },
    ];

    const segmentDropdown = [
      { value: "10", label: "House-NA" },
      { value: "11", label: "House-S" },
      { value: "12", label: "House-M" },
      { value: "13", label: "House-L" },
      { value: "30", label: "House-XL" },
      { value: "14", label: "HouseVac-S" },
      { value: "15", label: "HouseVac-M" },
      { value: "16", label: "HouseVac-L" },
      { value: "17", label: "THHO3fl-S" },
      { value: "18", label: "THHO3fl-M" },
      { value: "19", label: "THHO3fl-L" },
      { value: "40", label: "THHO3fl-XL" },
      { value: "20", label: "Condo-NA" },
      { value: "21", label: "Condo-S" },
      { value: "22", label: "Condo-M" },
      { value: "23", label: "Condo-L" },
      { value: "24", label: "CondoVac-Sergt" },
      { value: "25", label: "CondoVac-M" },
      { value: "26", label: "CondoVac-L" },
    ];

    const statusLeadContract = [
      { label: "เลือกทั้งหมด", value: "ALL" },
      { label: "POTENTIAL", value: "POTENTIAL" },
      { label: "ติดตามผล", value: "FOLLOW" },
      { label: "ติดสัญญาแล้ว", value: "IN_CONTRACT" },
    ];

    const statusLead = [
      { label: leadStatus.PENDING, value: "PENDING" },
      { label: leadStatus.IN_PROCESS, value: "IN_PROCESS" },
      { label: leadStatus.DONE, value: "DONE" },
      { label: leadStatus.EXPIRED, value: "EXPIRED" }
    ];

    const monthDropdown = [
      { label: "มกราคม", value: "1" },
      { label: "กุมภาพันธ์", value: "2" },
      { label: "มีนาคม", value: "3" },
      { label: "เมษายน", value: "4" },
      { label: "พฤษภาคม", value: "5" },
      { label: "มิถุนายน", value: "6" },
      { label: "กรกฎาคม", value: "7" },
      { label: "สิงหาคม", value: "8" },
      { label: "กันยายน", value: "9" },
      { label: "ตุลาคม", value: "10" },
      { label: "พฤศจิกายน", value: "11" },
      { label: "ธันวาคม", value: "12" },
    ];

    const ratingDropdown = [
      { label: "N/A", value: "0" },
      { label: "1 คะแนน", value: "1" },
      { label: "2 คะแนน", value: "2" },
      { label: "3 คะแนน", value: "3" },
      { label: "4 คะแนน", value: "4" },
      { label: "5 คะแนน", value: "5" },
    ];

    const query = {
      leadName: null,
      leadStatus: null,
      page: 1
    };

    return {
      pageWrapper,
      leadName: null,
      daterange: [],
      showDialog: false,
      file: {
        codes: [],
      },
      total: 1,
      leadList: [],
      permission:
        JSON.parse(localStorage.getItem("adminRolePermission")) || null,
      projectTypesDropdown,
      projectType: [],
      segmentDropdown,
      segmentType: [],
      projectGroupDropdown: [],
      groupType: [],
      serviceGroupType: null,
      projectSelect: [],
      projectIdsBySegmentFilter: [],
      projectIdsByGroupFilter: [],
      projectIdsByTypeFilter: [],
      segmentDropdownChanging: [],
      projectGroupDropdownChanging: [],
      isAllProject: true,
      isGenerateLead: false,
      statusLeadContract,
      saleStatus: [],
      agentDropdown: [],
      agentId: null,
      houseAgeStart: null,
      houseAgeEnd: null,
      packageExpire: null,
      isNeverBuyPackage: false,
      areaTypeStart: null,
      areaTypeEnd: null,
      monthDropdown,
      expiredMonth: null,
      statusLead,
      query,
      ratingDropdown,
      rating: null,
      serviceIds: null,
      packageIds: null,
      packagePeriodType: null,
      isNeverCall: false
    };
  },
  computed: {
    isPermissionImportCSV() {
      return !!(this.permission && this.permission.role === permissionRole.LMM);
    },
    projectIdsByFilter() {
      // กรณีมี projectType (type ของโครงการ)
      if (this.projectIdsByTypeFilter.length > 0) {
        let projectIds = this.projectIdsByTypeFilter;
        if (
          this.projectIdsBySegmentFilter.length > 0 ||
          this.projectIdsByGroupFilter.length > 0
        ) {
          projectIds = this.projectIdsByTypeFilter.filter((typeId) => {
            const inSegment = this.projectIdsBySegmentFilter.length === 0
              || this.projectIdsBySegmentFilter.includes(typeId);
            const inGroup = this.projectIdsByGroupFilter.length === 0
              || this.projectIdsByGroupFilter.includes(typeId);

            return inSegment && inGroup;
          });
        }

        return projectIds;
      }

      // กรณีมี segmentType (Segment โครงการ)
      if (this.projectIdsBySegmentFilter.length > 0) {
        let projectIds = this.projectIdsBySegmentFilter;

        if (this.projectIdsByGroupFilter.length > 0) {
          projectIds = this.projectIdsBySegmentFilter.filter((typeId) =>
            this.projectIdsByGroupFilter.includes(typeId)
          );
        }

        return projectIds;
      }

      // กรณีมี groupType (Project Group)
      if (this.projectIdsByGroupFilter.length > 0) {
        return this.projectIdsByGroupFilter;
      }

      return null;
    },
    segmentChanging() {
      if (this.segmentDropdownChanging.length > 0) {
        return this.segmentDropdownChanging;
      }

      return this.segmentDropdown;
    },
    groupChanging() {
      if (this.projectGroupDropdownChanging.length > 0) {
        return this.projectGroupDropdownChanging;
      }

      return this.projectGroupDropdown;
    },
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.leadList.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page || 1;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    packagePeriodTypeMapping() {
      return packagePeriodTypeMapping
    }
  },
  watch: {
    async projectType(newValue) {
      if (newValue.length > 0) {
        // ลด segment Dropdown ตาม
        this.segmentDropdownChanging = this.segmentDropdown.filter((segment) =>
          newValue === "H"
            ? segment.label.toLowerCase().includes("condo")
            : !segment.label.toLowerCase().includes("condo")
        );
      } else {
        this.segmentDropdownChanging = [];
      }
    },
    async segmentType(newValue, oldValue) {
      if (newValue.length > 0) {
        const isAddSegmentType = newValue.length > oldValue.length;
        const segmentTypeChanging = await this.getSegmentTypeChanging(newValue);

        // ถ้าเกิดเป็นการลบให้ set projectIdsBySegmentFilter ใหม่
        if (!isAddSegmentType) this.projectIdsBySegmentFilter = [];

        let projectIdsBySegment;
        if (this.projectIdsBySegmentFilter.length > 0) {
          projectIdsBySegment =
            this.projectIdsBySegmentFilter.concat(segmentTypeChanging);
        } else {
          projectIdsBySegment = segmentTypeChanging;
        }
        this.projectIdsBySegmentFilter = [...new Set(projectIdsBySegment)];

        // กรอง project group dropdawn ตาม segment ที่เลือก
        this.projectGroupDropdownChanging = this.projectGroupDropdown.filter(
          (group) =>
            group.segment_by_project_id.find((i) => i.includes(newValue))
        );
      } else {
        this.projectIdsBySegmentFilter = [];
        this.projectGroupDropdownChanging = [];
      }
    },
    async groupType(newValue, oldValue) {
      if (newValue.length > 0) {
        const isAddGroupType = newValue.length > oldValue.length;

        // ถ้าเกิดเป็นการลบให้ set projectIdsByGroupFilter ใหม่
        if (!isAddGroupType) this.projectIdsByGroupFilter = [];
        this.getProjectIdsByGroupFilter(newValue);
      } else {
        this.projectIdsByGroupFilter = [];
      }
    },
    isAllProject(newValue) {
      if (newValue === true) {
        this.projectType = [];
        this.segmentType = [];
        this.groupType = [];
        this.projectSelect = [];
        this.projectIdsBySegmentFilter = [];
        this.projectIdsByGroupFilter = [];
        this.projectIdsByTypeFilter = [];
      }
    },
    agentId(newValue) {
      if (!newValue) {
        this.saleStatus = [];
      }
    },
    "$route.query": async function watchRouteQuery() {
      this.setupForm();
      this.setupData();

      const pageContent = this.$refs.pageEl?.$el?.querySelector(".page-content");
      if (pageContent) pageContent.scrollTop = 0;
    },
    packageExpire(newValue) {
      if (!newValue) this.packagePeriodType = null;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
      this.setupProjectGroup();
      this.setupLeadAgent();
    },
    setupForm() {
      this.query = {
        leadName: this.$route.query.leadName || null,
        leadStatus: this.$route.query.leadStatus || null,
        page: +this.$route.query.page || null
      };
    },
    async setupData() {
      const { leads, count } = await this.fetchLeadList();

      this.total = count;
      this.leadList = leads.map((lead) => {
        const { name } = lead;
        const startDate = lead.start_date;
        const endDate = lead.end_date;
        const durationDate = `${startDate} - ${endDate}`;
        const { admin } = lead;
        const { id } = lead;
        const leadStatusClassList = [lead.status];
        const leadStatusTH = leadStatus[lead.status];
        const route = { name: "LeadManagementHomePage", params: { id } };
        const isPermissionAgent = !!(this.permission && this.permission.role === permissionRole.LMA);
        const isDisable = isPermissionAgent &&
          lead.status === leadHomeManagementStatusENG.EXPIRED;

        return {
          id,
          name,
          durationDate,
          leadStatusTH,
          admin,
          route,
          leadStatusClassList,
          status: lead.status,
          isDisable
        };
      });
    },
    async fetchLeadList() {
      const params = {
        leadName: this.query.leadName || "",
        leadStatus: this.query.leadStatus || "",
        page: +this.query.page || 1
      };

      const response = await baanRueJaiClient.admin.lead.list(params);

      return response.data.result;
    },
    async handleClickCreate() {
      if (!this.leadName) {
        this.$message.error("กรุณาใส่ชื่อ lead");
        return;
      }

      if (this.daterange.length === 0) {
        this.$message.error("กรุณาใส่เลือกช่วงเวลา");
        return;
      }

      if (
        (this.areaTypeStart || this.areaTypeEnd) &&
        (!this.areaTypeStart || !this.areaTypeEnd)
      ) {
        this.$message.error("กรุณาใส่ 'พื้นที่ใช้สอย' เริ่มต้นและสิ้นสุดให้ครบ");
        return;
      }

      if (
        (this.houseAgeStart || this.houseAgeEnd) &&
        (!this.houseAgeStart || !this.houseAgeEnd)
      ) {
        this.$message.error("กรุณาใส่ 'อายุบ้านเริ่มต้น' เริ่มต้นและสิ้นสุดให้ครบ");
        return;
      }

      if (
        this.houseAgeStart &&
        this.houseAgeEnd &&
        (this.houseAgeStart.length !== 4 || this.houseAgeEnd.length !== 4)
      ) {
        this.$message.error("กรุณาใส่ 'อายุบ้านเริ่มต้น' ให้อยู่ในรูปแบบ ค.ศ.");
        return;
      }

      if (this.packageExpire && !this.packagePeriodType) {
        this.$message.error("กรณาเลือก 'ประเภทช่วงเวลา'");
        return;
      }

      if (!this.packageExpire && this.packagePeriodType) {
        this.$message.error("กรณาเลือก 'ช่วงเวลาหมดอายุ'");
        return;
      }

      const [start, end] = this.daterange;

      let startPackage;
      let endPackage;
      if (this.packageExpire && this.packageExpire.length > 0) {
        const [startPack, endPack] = this.packageExpire;

        startPackage = startPack;
        endPackage = endPack;
      }

      const usableArea = this.areaTypeStart
        ? `${this.areaTypeStart}-${this.areaTypeEnd}`
        : null;

      const params = {
        name: this.leadName,
        effective_date: { start, end },
        service_category_id: this.serviceGroupType && this.serviceGroupType.id
          ? +this.serviceGroupType.id
          : null,
        project_type: this.checkExistValues(this.projectType),
        project_group: this.checkExistValues(this.groupType),
        segments: this.checkExistValues(this.segmentType),
        projects:
          this.projectSelect && this.projectSelect.length > 0
            ? this.projectSelect.map((project) => project.project_id)
            : null,
        house_age_start: this.checkExistValues(this.houseAgeStart),
        house_age_end: this.checkExistValues(this.houseAgeEnd),
        usable_area: usableArea,
        is_never_buy_package: this.isNeverBuyPackage,
        sale_status: this.checkExistValues(this.saleStatus),
        agent_id: this.checkExistValues(this.agentId, true),
        package_expire: startPackage
          ? { start: startPackage, end: endPackage }
          : null,
        expired_month: this.checkExistValues(this.expiredMonth, true),
        rating: this.checkExistValues(this.rating),
        service_ids: this.checkExistValues(this.serviceIds),
        package_ids: this.checkExistValues(this.packageIds),
        package_period_type: this.checkExistValues(this.packagePeriodType),
        is_never_call: this.isNeverCall
      };

      try {
        await baanRueJaiClient.admin.lead.generateLead(params);

        this.setup();
        this.$message.success("บันทึกเรียบร้อย");
        this.clearGenerateLead();
      } catch (error) {
        if (
          error.response &&
          error.response.status &&
          error.response.status === 400
        ) {
          this.$message.error(error.response.data.message);
        } else {
          this.$message.error("ไม่สามารถเพิ่ม lead ได้");
        }
      }
    },
    checkExistValues(values, isTypeOutputNumber = false) {
      let value = null;
      if (values && values.length > 0) value = values;
      if (values && values.length > 0 && isTypeOutputNumber) value = +values;
      if (values && isTypeOutputNumber) value = +values;

      return value;
    },
    async handleChangeValue(key, value) {
      if (key === "segment") this.segmentType = value;
      if (key === "group") this.groupType = value;
      if (key === "status") {
        this.saleStatus = value;

        if (value.includes("ALL")) {
          this.saleStatus = ["POTENTIAL", "FOLLOW", "IN_CONTRACT"];
        }
      }
    },
    async setupProjectGroup() {
      this.projectGroupDropdown = await this.getProjectGroup();
    },
    async getProjectGroup() {
      const response =
        await baanRueJaiClient.admin.projects.getAllProjectGroup();

      return response.data.result;
    },
    async getSegmentTypeChanging(segmentIds) {
      const response = await baanRueJaiClient.admin.projects.getSegmentHome(
        segmentIds
      );

      return response.data.result.projects_by_segment;
    },
    async handleProjectIdsByType(projectIds) {
      this.projectIdsByTypeFilter = projectIds;
    },
    async getProjectIdsByGroupFilter(newValues) {
      newValues.forEach((item) => {
        const projectGroupSelect = this.projectGroupDropdown.find(
          (group) => group.project_group === item
        );

        if (!projectGroupSelect) return;

        if (this.projectIdsByGroupFilter.length > 0) {
          this.projectIdsByGroupFilter = this.projectIdsByGroupFilter.concat(
            projectGroupSelect.project_ids
          );
        } else {
          this.projectIdsByGroupFilter = projectGroupSelect.project_ids;
        }
      });

      this.projectIdsByGroupFilter = [...new Set(this.projectIdsByGroupFilter)];
    },
    handleClickOpenLead() {
      this.isGenerateLead = true;
    },
    async setupLeadAgent() {
      this.agentDropdown = await this.getLeadAgent();
    },
    async getLeadAgent() {
      const response =
        await baanRueJaiClient.admin.lead.getAdminPermissionAgent();

      return response.data.result;
    },
    async clearGenerateLead() {
      // close generate lead
      this.isGenerateLead = false;

      // set default filter generate lead
      this.leadName = null;
      this.daterange = [];
      this.total = 1;
      this.projectType = [];
      this.segmentType = [];
      this.groupType = [];
      this.serviceGroupType = null;
      this.projectSelect = [];
      this.projectIdsBySegmentFilter = [];
      this.projectIdsByGroupFilter = [];
      this.projectIdsByTypeFilter = [];
      this.segmentDropdownChanging = [];
      this.projectGroupDropdownChanging = [];
      this.isAllProject = true;
      this.saleStatus = [];
      this.agentId = null;
      this.houseAgeStart = null;
      this.houseAgeEnd = null;
      this.packageExpire = null;
      this.packagePeriodType = null;
      this.isNeverBuyPackage = false;
      this.areaTypeStart = null;
      this.areaTypeEnd = null;
      this.expiredMonth = null;
      this.rating = null;
      this.packageIds = null;
      this.isNeverCall = false;
    },
    async handleClickRemove(leadId) {
      try {
        await baanRueJaiClient.admin.lead.deleteLead(leadId);
        await this.setupData();
        this.$message.success("ลบ lead เรียบร้อย");
      } catch (error) {
        this.$message.error("เกิดข้อผิดพลาดในการลบ lead");
      }
    },
    async handleClickSearch() {
      const route = {
        ...this.$route,
        query: {
          leadName: this.query.leadName || "",
          leadStatus: this.query.leadStatus || "",
          page: +this.query.page || 1
        }
      };

      this.$router.replace(route);
    },
    handleCurrentChange(page) {
      const route = {
        ...this.$route,
        query: {
          ...this.$route.query,
          page
        }
      };

      this.$router.replace(route);
    },
    replaceNonNumericToServiceIds() {
      const regex = /[^0-9,]/g;
      this.serviceIds = (this.serviceIds || "").replace(regex, '');

      if (this.serviceIds.charAt(0) === ',') {
        this.serviceIds = this.serviceIds.slice(1);
      }
    },
    replaceNonNumericToPackageIds() {
      const regex = /[^0-9,]/g;
      this.packageIds = (this.packageIds || "").replace(regex, "");

      if (this.packageIds.charAt(0) === ",") {
        this.packageIds = this.packageIds.slice(1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../lead";

.wrapper {
  padding: ($space / 2) $space;
}

.lead-manage-row {
  display: grid;
  grid-gap: $space;
  grid-template-columns: 35px 350px 200px 100px 200px 300px;

  border-bottom: $border;
  padding: 15px 10px;

  font-size: 16px;

  &:hover:not(.header) {
    text-decoration: none;
    background: #efefef;
    color: black;
  }

  &.header {
    color: #999;
    font-size: 14px;
  }
}

.csv-input {
  height: 40px;
}

.lead-generate {
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.length-home {
  width: 98%;
}

.status-detail {
  color: rgb(168, 21, 21);
  font-size: 13px;
  display: inline;
}

.voucher-remove-button {
  display: inline-block;
  height: 32px;
  min-width: 32px;
  border-radius: 10em;
  border: 1px solid #e0e0e0;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;

  a {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.29;
    letter-spacing: -0.1px;
    color: $black;
    padding: 3px 20px;
  }
}

.lead-disabled {
  pointer-events: none;
  background-color: rgb(240, 238, 238);
  opacity: 5;
}
</style>